/*
 *
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3960 Freedom Circle Suite 201 Santa Clara, CA 95054
 * All rights reserved.
 */

import React from 'react'
import { useTranslation } from 'react-i18next'
import { WidgetGuard } from 'features/types'
import { useDashboardWidgetSetting } from 'hooks/useDashboardState'
import ErrorMessage from 'components/share/ErrorMessage'
import { ComparisonMode } from 'enums'
import { MAX_MATRIXED_ITEM_COUNT } from '../../../utils'
import { TimelineComparisonWidget } from '../../../types'
import { getComparisonModeLangKey } from '../../utils'

const ThemesMatrixedItemCountGuard: WidgetGuard = ({ widgetId, children }) => {
  const widgetSetting = useDashboardWidgetSetting<TimelineComparisonWidget>(widgetId)
  const { t } = useTranslation()

  const matrixedItemCount = widgetSetting.pivotThemeInfos?.length || 0

  if (matrixedItemCount === 0) {
    return (
      <ErrorMessage>
        {t('noSelectPivots', {
          comparisonModeOption: t(getComparisonModeLangKey(ComparisonMode.THEMES))
        })}
      </ErrorMessage>
    )
  }

  if (matrixedItemCount > MAX_MATRIXED_ITEM_COUNT) {
    return (
      <ErrorMessage>{t('tooManyMatrixedItems', { num: MAX_MATRIXED_ITEM_COUNT })}</ErrorMessage>
    )
  }

  return children
}

export default ThemesMatrixedItemCountGuard
